import { action } from 'typesafe-actions';
// Load project profile
export const LOAD_PROFILE_REQUEST = '[Request] Load profile';
export const LOAD_PROFILE_SUCCESS = '[Success] Load profile';
export const LOAD_PROFILE_FAILURE = '[Failure] Load profile';
export const loadProfileRequest = (address) => action(LOAD_PROFILE_REQUEST, { address });
export const loadProfileSuccess = (address, profile) => action(LOAD_PROFILE_SUCCESS, { address, profile });
export const loadProfileFailure = (address, error) => action(LOAD_PROFILE_FAILURE, { address, error });
// Load profiles request
export const LOAD_PROFILES_REQUEST = '[Request] Load profiles';
export const LOAD_PROFILES_SUCCESS = '[Success] Load profiles';
export const LOAD_PROFILES_FAILURE = '[Failure] Load profiles';
export const loadProfilesRequest = (addresses) => action(LOAD_PROFILES_REQUEST, { addresses });
export const loadProfilesSuccess = (profiles) => action(LOAD_PROFILES_SUCCESS, { profiles });
export const loadProfilesFailure = (error) => action(LOAD_PROFILES_FAILURE, { error });
// Set profile alias
export const SET_PROFILE_AVATAR_ALIAS_REQUEST = '[Request] Set profile avatar alias';
export const SET_PROFILE_AVATAR_ALIAS_SUCCESS = '[Success] Set profile avatar alias';
export const SET_PROFILE_AVATAR_ALIAS_FAILURE = '[Failure] Set profile avatar alias';
export const setProfileAvatarAliasRequest = (address, alias) => action(SET_PROFILE_AVATAR_ALIAS_REQUEST, { address, alias });
export const setProfileAvatarAliasSuccess = (address, alias, version) => action(SET_PROFILE_AVATAR_ALIAS_SUCCESS, {
    address,
    alias,
    version
});
export const setProfileAvatarAliasFailure = (address, error) => action(SET_PROFILE_AVATAR_ALIAS_FAILURE, { address, error });
// Set profile description
export const SET_PROFILE_AVATAR_DESCRIPTION_REQUEST = '[Request] Set profile avatar description';
export const SET_PROFILE_AVATAR_DESCRIPTION_SUCCESS = '[Success] Set profile avatar description';
export const SET_PROFILE_AVATAR_DESCRIPTION_FAILURE = '[Failure] Set profile avatar description';
export const setProfileAvatarDescriptionRequest = (address, description) => action(SET_PROFILE_AVATAR_DESCRIPTION_REQUEST, { address, description });
export const setProfileAvatarDescriptionSuccess = (address, description, version) => action(SET_PROFILE_AVATAR_DESCRIPTION_SUCCESS, {
    address,
    description,
    version
});
export const setProfileAvatarDescriptionFailure = (address, error) => action(SET_PROFILE_AVATAR_DESCRIPTION_FAILURE, { address, error });
// Errors
export const CLEAR_PROFILE_ERROR = '[Clear] Clear profile error';
export const clearProfileError = () => action(CLEAR_PROFILE_ERROR);
// Change Profile
export const CHANGE_PROFILE = 'Change Profile';
export const changeProfile = (address, profile) => action(CHANGE_PROFILE, { address, profile });
//# sourceMappingURL=actions.js.map